import styled from "styled-components";
import { Button } from "iparque-components";

export const ContentContainer = styled.div`
  display: flex;
  max-width: 800px;

  > svg {
    fill: ${({ theme }) => theme.formField.color.primary.input};
    margin-right: 15px;
    width: 100px;
  }
`;

export const StyledButton = styled(Button)`
  margin-left: auto;
`;
